<template>
    <div class="panel panel-default app-tab-config-element">
        <div class="panel-heading app-tab-config-element-heading" @click="toggle">
            <div style="float:right">
                <i class="fa" :class="open ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                <button type="button" class="btn btn-sm btn-default" style="border: 0"
                        @click.stop="removeElement"
                        content="Element löschen" v-tippy>
                    <i class="fa fa-close" style="color: black"></i>
                </button>
            </div>
            <label class="box-title">{{
                    this.titles[isFeed() ? this.record.module : this.record.list_module].toString().toUpperCase()
                }}</label>
        </div>
        <div class="panel-body" v-if="open">
            <vue-toastr ref="notificationToast"></vue-toastr>
            <div class="ibox box-primary" style="margin-bottom: 0">
                <div class="ibox-content">
                    <div class="form-group">
                        <label>Interne Bezeichnung</label>
                        <a v-if="isModule(['ListSeparator', 'ListButton'])" href="" data-toggle="tooltip" data-placement="right" title=""
                           data-original-title="Dieser Text wird, sobald Sie speichern, für die App automatisch übersetzt. Sie können die Übersetzung bearbeiten. Klicken Sie nach dem Speichern auf das Weltkugel-Icon, um auf die Übersetzungsseite zu gelangen.">
                            <i aria-hidden="true" class="fa fa-globe" style="color: red; font-size: 18px"></i>
                        </a>
                        <br>
                        <input type="text"
                               class="form-control"
                               v-model="record.name"
                               :disabled="isAdmin != 1 && !isModule(['ListSeparator', 'ListButton'])">
                    </div>

                    <div class="form-group"
                         v-if="isFeed() && !isModule(['FeedHeadlineModule', 'MagazineModule', 'UniversalSliderModule'])">
                        <label>Anzeigename <a class="fa fa-question-circle" v-tippy
                                              content="Name, der über dem Modul im Feed in der App angezeigt wird."></a>
                            <a href="" data-toggle="tooltip" data-placement="right" title=""
                               data-original-title="Dieser Text wird, sobald Sie speichern, für die App automatisch übersetzt. Sie können die Übersetzung bearbeiten. Klicken Sie nach dem Speichern auf das Weltkugel-Icon, um auf die Übersetzungsseite zu gelangen.">
                                <i aria-hidden="true" class="fa fa-globe" style="color: red; font-size: 18px"></i>
                            </a>
                        </label>
                        <br>
                        <input type="text"
                               class="form-control"
                               v-model="record.display_name">
                    </div>

                    <div class="form-group" v-if="isList()">
                        <label>Modul</label>
                        <br>
                        <select class="form-control"
                                v-model="record.list_module"
                                :disabled="isAdmin != 1">
                            <option value="ListHeadline">Überschrift</option>
                            <option value="ListSeparator">Separator</option>
                            <option value="ListButton">Listenelement</option>
                            <option value="ListLinkBox">Infobox</option>
                            <option value="ListCustomerCard">Kundenkartenvorschau</option>
                        </select>
                    </div>

                    <div class="form-group" v-if="isModule(['ListButton','ListLinkBox'])">
                        <label>Art der Verlinkung</label>
                        <select v-model="record.link_type" class="form-control"
                                style="margin-top: 5px"
                                :disabled="isAdmin != 1">
                            <option value="internal">Interne Verlinkung</option>
                            <option value="external">Externe Verlinkung</option>
                        </select>
                    </div>

                    <div class="form-group"
                         v-if="isFeed() || isModule(['ListButton','ListLinkBox']) && record.link_type === 'internal'">
                        <label>{{ appTabConfig.type === 'list' ? 'Interne Verlinkung' : 'Modul' }}</label>
                        <br>
                        <select class="form-control"
                                v-model="record.module"
                                :disabled="isAdmin != 1">
                            <option v-if="isFeed()" value="FeedHeadlineModule">Überschrift</option>
                            <option value="NewsModule">News</option>
                            <option value="MagazineModule">WKZ-Trendblog</option>
                            <option value="CampaignsModule">Gutscheine, Bonus und Einladungen</option>
                            <option value="PersonalShoppingModule">Personal Shopping</option>
                            <option v-if="isFeed()" value="UniversalSliderModule">Info-Slider</option>
                            <option v-if="isList()" value="ReceiptModule">Kassenbons</option>
                            <option v-if="isList()" value="SettingsModule">Einstellungen</option>
                            <option v-if="isList()" value="AccountModule">Stammdaten ändern</option>
                            <option v-if="isList()" value="StaticInformationModule">Statische Informationsseite</option>
                            <option v-if="isFeed()" value="AdvertisementModule">Marketing-Slider</option>
                            <option value="StoreBranchesModule">Filialen</option>
                        </select>
                    </div>

                    <div class="form-group"
                         v-if="isModule(['MagazineModule']) || isInternalLink('MagazineModule')">
                        <label for="">Kategorie</label>
                        <Select2 v-model="record.category_id" :options="Categories"
                                 :disabled="isAdmin != 1"/>
                    </div>

                    <div class="form-group"
                         v-if="isModule(['StaticInformationModule']) || isInternalLink('StaticInformationModule')">
                        <label for="">Statische Informationsseite</label>
                        <Select2 v-model="record.static_information_page_id" :options="StaticInformationPages"
                                 :disabled="isAdmin != 1"/>
                    </div>

                    <div class="form-group"
                         v-if="isModule(['UniversalSliderModule']) || isInternalLink('UniversalSliderModule')">
                        <label for="">Info-Slider</label>
                        <Select2 v-model="record.universal_slider_id" :options="UniversalSliders"
                                 :disabled="isAdmin != 1"/>
                    </div>

                    <div class="form-group" v-if="isModule(['ListLinkBox', 'ListCustomerCard'])">
                        <label>Überschrift</label>
                        <a href="" data-toggle="tooltip" data-placement="right" title=""
                           data-original-title="Dieser Text wird, sobald Sie speichern, für die App automatisch übersetzt. Sie können die Übersetzung bearbeiten. Klicken Sie nach dem Speichern auf das Weltkugel-Icon, um auf die Übersetzungsseite zu gelangen.">
                            <i aria-hidden="true" class="fa fa-globe" style="color: red; font-size: 18px"></i>
                        </a>
                        <br>
                        <input name="title"
                               type="text"
                               id="title"
                               class="form-control"
                               v-model="record.title">
                    </div>

                    <div class="form-group" v-if="isModule(['FeedHeadlineModule','ListHeadline'])">
                        <label>Textinhalt</label>
                        <a href="" data-toggle="tooltip" data-placement="right" title=""
                           data-original-title="Dieser Text wird, sobald Sie speichern, für die App automatisch übersetzt. Sie können die Übersetzung bearbeiten. Klicken Sie nach dem Speichern auf das Weltkugel-Icon, um auf die Übersetzungsseite zu gelangen.">
                            <i aria-hidden="true" class="fa fa-globe" style="color: red; font-size: 18px"></i>
                        </a>
                        <br>
                        <input type="text"
                               class="form-control"
                               v-model="record.text">
                        <br>
                        <div v-if="isModule(['FeedHeadlineModule'])">
                            <button @click="changeVariablesVisible" style="background: white; border: 0"><b>Variablen
                                <span class="fa fa-chevron-down"></span></b>
                            </button>
                            <div v-for="key in Object.keys(customerVariables)" v-if="variablesVisible">
                                <div style="width:300px; display: inline-block"><b>@kunde_{{
                                        customerVariables[key]
                                    }}</b></div>
                                {{ customerVariablesTranslations[key] }}
                            </div>
                        </div>
                    </div>

                    <div class=" form-group " v-if="isModule(['ListLinkBox'])">
                        <label>Fließtext</label>
                        <a href="" data-toggle="tooltip" data-placement="right" title=""
                           data-original-title="Dieser Text wird, sobald Sie speichern, für die App automatisch übersetzt. Sie können die Übersetzung bearbeiten. Klicken Sie nach dem Speichern auf das Weltkugel-Icon, um auf die Übersetzungsseite zu gelangen.">
                            <i aria-hidden="true" class="fa fa-globe" style="color: red; font-size: 18px"></i>
                        </a>
                        <br>
                        <input type="text"
                               class="form-control"
                               v-model="record.text">
                    </div>

                    <div class="form-group"
                         v-if="isModule(['ListButton','ListLinkBox']) && record.link_type === 'external'">
                        <label>Link</label>
                        <br>
                        <input type="text"
                               class="form-control"
                               v-model="record.external_link"
                               :disabled="isAdmin != 1">
                    </div>

                    <div class="form-group" v-if="isModule(['ListButton', 'ListLinkBox'])">
                        <label>Icon</label>
                        <br>
                        <icon-picker :model="record" :prop-name="'icon'"></icon-picker>
                    </div>

                    <div class="form-group"
                         v-if="isModule(['NewsModule','MagazineModule','AdvertisementModule','CampaignsModule','PersonalShoppingModule','StoreBranchesModule'])">
                        <label>Anzahl an Slidern, die im Feed angezeigt werden</label>
                        <br>
                        <input type="number"
                               class="form-control"
                               v-model="record.slider_count"
                               :disabled="isAdmin != 1">
                    </div>

                    <div class="form-group"
                         v-if="isModule(['NewsModule','MagazineModule','CampaignsModule'])">
                        <input type="checkbox"
                               v-model="record.show_link"
                               :disabled="isAdmin != 1">
                        <label>Verlinkung auf Modul aktivieren</label>
                    </div>

                    <div v-if="isModule(['ListCustomerCard'])">
                        <div class="form-group">
                            <input type="checkbox"
                                   v-model="record.show_title"
                                   :disabled="isAdmin != 1">
                            <label>Titel anzeigen</label>
                        </div>

                        <div class="form-group">
                            <input type="checkbox"
                                   v-model="record.show_first_name"
                                   :disabled="isAdmin != 1">
                            <label>Vorname anzeigen</label>
                        </div>

                        <div class="form-group">
                            <input type="checkbox"
                                   v-model="record.show_last_name"
                                   :disabled="isAdmin != 1">
                            <label>Nachname anzeigen</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from "../common/modal/Modal";
import VueToastr from "vue-toastr";
import IconPicker from "../common/icon-picker/IconPicker.vue";

export default {
    name: 'AppTabConfigElementForm',
    components: {
        IconPicker,
        Modal,
        VueToastr
    },
    methods: {
        isModule(modules) {
            if (this.appTabConfig.type === 'list') return modules.includes(this.record.list_module);
            return modules.includes(this.record.module);
        },
        isInternalLink(module) {
            return this.isList() && this.record.module === module && this.record.link_type === 'internal';
        },
        isFeed() {
            return this.appTabConfig.type === 'feed';
        },
        isList() {
            return this.appTabConfig.type === 'list';
        },
        toggle() {
            // Sortable does not swallow the click that ends a drag which changed the order
            if (this.dragging) return;
            this.open = !this.open;
        },
        changeVariablesVisible() {
            this.variablesVisible = !this.variablesVisible;
        },
        removeElement() {
            this.appTabConfig.elements.splice(this.index, 1);
            this.$parent.$forceUpdate();
        },
        extractClientData(property, modelPropertyName) {
            try {
                let data = property[this.appTabConfig?.client_id];
                if (!data) return [];
                if (!this.record[modelPropertyName] && data[0]) {
                    this.record[modelPropertyName] = data[0].id;
                }
                return data;
            } finally {
                this.$forceUpdate();
                this.$parent.$forceUpdate();
            }
        }
    },
    data() {
        return {
            open: !this.record.id,
            variablesVisible: false,
            titles: {
                FeedHeadlineModule: 'Überschrift',
                AccountModule: 'Profil',
                NewsModule: 'News',
                CampaignsModule: 'Gutscheine, Bons und Einladungen',
                PersonalShoppingModule: 'Personal-Shopping',
                StoreBranchesModule: 'Filialen',
                MagazineModule: 'WKZ-Trendblog',
                UniversalSliderModule: 'Info-Slider',
                StaticInformationModule: 'Statische Informationsseite',
                AdvertisementModule: 'Marketing-Slider',
                ListHeadline: 'Überschrift',
                ListCustomerCard: 'Kundenkartenvorschau',
                ListSeparator: 'Separator',
                ListButton: 'Listenelement',
                ListLinkBox: 'Infobox'
            }
        };
    },
    computed: {
        Categories: function () {
            return this.extractClientData(this.categories, "category_id");
        },
        UniversalSliders: function () {
            return this.extractClientData(this.universalSliders, "universal_slider_id");
        },
        StaticInformationPages: function () {
            return this.extractClientData(this.staticInformationPages, "static_information_page_id");
        },
    },
    props: ['clients', 'isAdmin', 'record', 'index', 'appTabConfig', 'user', 'title', 'disabled', 'categories', 'universalSliders', 'staticInformationPages', 'customerVariables', 'customerVariablesTranslations', 'dragging']
}
</script>

<style scoped>
.app-tab-config-element-heading {
    cursor: move;
    user-select: none;
}

.app-tab-config-element-heading label {
    cursor: move;
}
</style>
<style>
.ckeditor-wrapper .ck-content {
    min-height: 300px;
}

label {
    margin-bottom: 6px;
    margin-top: 9px;
}
</style>
